import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigateNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z" })
});
export default SvgNavigateNext;
